import { Type } from '@angular/core';

import { ISnCanDisable } from './disable.mixin';

export interface ISnHasTabindex {
  tabIndex: number;
}

export function mixinTabIndex<T extends Type<ISnCanDisable>>(
  base: T,
  defaultTabIndex: number = 0,
): Type<ISnHasTabindex> & T {
  return class extends base {
    private _tabIndex: number = defaultTabIndex;

    constructor(...args: any[]) {
      super(...args);
    }

    get tabIndex(): number {
      return this.disabled ? -1 : this._tabIndex;
    }
    set tabIndex(value: number) {
      this._tabIndex = value != null ? value : defaultTabIndex;
    }
  };
}
